import Shortcut from '@/domain/shortcuts';
import { useErrorHandler } from '@/hooks/useErrorHandler';
import { RootState } from '@/store';
import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import itemsGetByShortcuts, {
  ResolvedData,
} from '@/app/items/itemsGetByShortcuts';

const buildShortcutsHooks = (usecase: any) => (type: 'launch' | 'archive') => {
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const { throwError } = useErrorHandler();
  const [itemCount, setItemCount] = useState<number | null>(null);
  const [eventIds, setEventIds] = useState<number[]>([]);
  const [activeShortcut, setActiveShortcut] = useState<Shortcut | null>(null);

  const shortcuts = useSelector<RootState, Shortcut[] | undefined>((state) =>
    type === 'launch'
      ? state.domain.launch.shortcuts
      : state.domain.archives.shortcuts
  );

  const fetchItemsAsync = useCallback(
    async (shortcut: Shortcut, _page?: number) => {
      setIsLoading(true);
      setIsError(false);

      try {
        const data = await usecase({
          type,
          shortcutId: shortcut.id,
        });

        if (data) {
          setActiveShortcut(shortcut);
          setItemCount(data.totalCount ?? null);
          setEventIds(data.eventIds ?? []);
          return data;
        }
      } catch (error) {
        throwError(error, 'LISTSの取得に失敗しました');
      } finally {
        setIsLoading(false);
      }
    },
    [throwError, type]
  );

  const clearActiveShortcut = useCallback(() => {
    setActiveShortcut(null);
    setItemCount(null);
    setEventIds([]);
  }, []);

  return {
    shortcuts,
    activeShortcut,
    isLoading,
    isError,
    fetchItemsAsync,
    clearActiveShortcut,
    itemCount,
    eventIds,
  };
};

export const useShortcuts = buildShortcutsHooks(itemsGetByShortcuts);
